<template>
  <div>
    <v-tabs
      class="base-filter-tab mb-5"
      v-model="tab"
      align-tabs="start"
      color="#BD9478"
    >
      <v-tab
        :to="filter.route"
        v-for="filter in filters"
        :key="filter.id"
        :value="filter.id"
        :style="{ color: tab === filter.id ? '#BD9478' : '#7C7C7C' }"
      >
        <div class="d-flex align-center ga-1">
          <v-icon
            :icon="filter.icon"
            :color="tab === filter.id ? '#BD9478' : '#7C7C7C'"
          />
          {{ filter.name }}
        </div>
      </v-tab>
    </v-tabs>
    <hr class="bottom-border" />
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
    },
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>

<style lang="scss">
.base-filter-tab {
  .v-btn__content {
    font-size: 22px !important;
    font-weight: 400;
    letter-spacing: 0;
  }
  .v-icon {
    font-size: 18px;
  }
}

.bottom-border {
  margin-top: -22px;
  margin-bottom: 40px;
  height: 1px;
  border: 0;
  border-bottom: 2px solid $tableOrderColor;
  padding: 0;
}
</style>
